/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const OrganizationRoles = {
    Admin: 'admin',
    Member: 'member',
    RiskManager: 'risk_manager',
    PolicyManager: 'policy_manager',
    RegistrationManager: 'registration_manager',
} as const;

export type OrganizationRoles = typeof OrganizationRoles[keyof typeof OrganizationRoles];



